import { render, staticRenderFns } from "./BasicActions.vue?vue&type=template&id=f16bdc7c&scoped=true"
import script from "./BasicActions.vue?vue&type=script&lang=js"
export * from "./BasicActions.vue?vue&type=script&lang=js"
import style0 from "./BasicActions.vue?vue&type=style&index=0&id=f16bdc7c&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f16bdc7c",
  null
  
)

export default component.exports